import * as React from "react";

const LoadingContext = React.createContext(null);

const LoaderProvider = LoadingContext.Provider

const LoaderConsumer = LoadingContext.Consumer

export { LoaderProvider, LoaderConsumer }